import $ from 'jquery';
import { FireComponent } from '@component';
import { lockBody } from '@utility';

export class SiteHeader extends FireComponent {
	constructor(id) {
		super(id);
	}

	get elements() {
		return {
			$mobileMenu: this.findElement('mobile-menu'),
		};
	}

	_initMobile() {
		// Adds sub menu buttons
		$('#mobile-menu .sub-menu').each( function() {
			var $parent = $(this).parent();

			$parent.append('<button class="absolute right-0 transform z-1 top-5 menu-button"><svg aria-hidden="true" height="20" width="30" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#178D81" d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"></path></svg></button>');
		});

		//Toggles sub menus
		$('.menu-button').on('click', function() {
			const $parent = $(this).parent();

			var $menu = $parent.find('.sub-menu').first();
			
			if ($(this).hasClass('open')) {
				$(this).removeClass('open');
				$parent.removeClass('sub-open');
				$menu.removeClass('open').css('max-height', 0);
			} else {
				$(this).addClass('open');
				$parent.addClass('sub-open');
				$menu.addClass('open').css('max-height', 'unset');
			}
		});

		//Replaced the word "Heart"
		$('.site-header a').each( function() {
			if ($(this).text().indexOf('Heart') >= 0) {
				var str = $(this).text();
				var splitted = str.split('Heart');
				var first = splitted[0].replace('Heart', '');
				$(this).html(first + '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 128 102.165" class="mx-1 site-header__heart"><path fill="#178d81" d="M154.867,4062.939a31.7,31.7,0,0,0-45.74,0l-3.9,4.01-3.9-4.01a31.7,31.7,0,0,0-45.743,0l-9.318,9.592a18.111,18.111,0,0,0,0,25.08L74.535,4126.7c.018.016.038.041.058.061l25.68,26.433a6.99,6.99,0,0,0,10.1,0l50.452-51.938h-.185l3.545-3.646a18.112,18.112,0,0,0,0-25.08Z" transform="translate(-41.23 -4053.189)" /></svg>' + splitted[1]);
			} 
		});

		//Open first Submenu inside Submenu, unless at depth 2.
		$('#mobile-menu .sub-menu').each(function () {
			var target = $(this).find('.sub-menu').not('.sub-menu-depth-2').first();
			var button = $(target).parent().find('.menu-button');
			if(target) {
				target.addClass('open').css('max-height', 'unset');
				button.addClass('open');
			}
		});

		//Toggle Mobile Menu
		this.elements.$mobileMenu.on('click', function() {
			if($(this).hasClass('open')) {
				$(this).removeClass('open');
				$('#mobile-menu').removeClass('open');
				$('.mobile-bg').removeClass('open');
				lockBody(false);
			} else {
				$(this).addClass('open');
				$('#mobile-menu').addClass('open');
				$('.mobile-bg').addClass('open');
				lockBody(true);
			}
		});
	}

	init() {
		if (!this.componentExists) return;
		this._initMobile();
	}
}
